import { render, staticRenderFns } from "./IFramePlugin.vue?vue&type=template&id=4d30cf5a&"
import script from "./IFramePlugin.vue?vue&type=script&lang=js&"
export * from "./IFramePlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports